import { createApp } from 'vue'
import App from './App.vue'
import { router, setupRouter } from './router'
import '@/assets/main.css'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

async function initializeApp() {
    await setupRouter() // 等待动态路由挂载
    const app = createApp(App)
    app.use(ElementPlus)
    app.use(router) // 使用已挂载动态路由的 router 实例
    app.mount('#app')
}

initializeApp().catch(error => {
    console.error('应用初始化失败:', error)
})
